import { Dcupl as dcuplCore } from './libs/dcupl';
import { DcuplList as dcuplList } from './libs/list';
export const Dcupl = dcuplCore;
export const DcuplList = dcuplList;
